import {
  type HighlightIconVariant,
  type IconName,
  RadioBox,
  RadioGroup,
} from '@dev-spendesk/grapes';
import { useEffect, useState } from 'react';

const RadioBoxDescription = ({ lines }: { lines: string[] }) => {
  return (
    <ul className="ml-16 list-disc">
      {lines.map((line, index) => (
        <li key={`RadioBoxDescriptionLine_${index + 1}`}>{line}</li>
      ))}
    </ul>
  );
};

type Props = {
  name: string;
  value?: string | null;
  options: {
    value: string;
    iconName: IconName;
    iconVariant: HighlightIconVariant;
    label: string;
    notes: string[];
  }[];
  onChange: (value: string) => void;
};

export const RadioListSelector = ({
  name,
  value,
  options,
  onChange,
}: Props) => {
  const [internalValue, setInternalValue] = useState<string | null>(null);

  useEffect(() => {
    if (value) {
      setInternalValue(value);
    }
  }, [value]);

  const handleChange = (targetValue: string) => {
    setInternalValue(targetValue);
    onChange(targetValue);
  };

  return (
    <RadioGroup
      className="mt-16 gap-16 text-left"
      name={name}
      value={internalValue}
      onChange={({ target }) => handleChange(target.value)}
      direction="column"
    >
      {options.map(({ notes, ...option }) => (
        <RadioBox
          key={option.value}
          {...option}
          description={<RadioBoxDescription lines={notes} />}
        />
      ))}
    </RadioGroup>
  );
};
